import styles from './styles.module.css';
import { HeaderComponent } from '../..';
import logo from '../../../Assets/Images/main-logo.png'

const FirstLogin = () => {
    return (
        <div className={styles.fullback}>
            <div className={styles.content_page_header}>
                <HeaderComponent />
            </div>
            <div className="layout_wrapper">
                <div className={styles.loginwithoutlogo}>
                    <img src={logo} alt='' style={{ width: 40, height: 40 }} />
                </div>
                <div className="admin_panel_wrp">
                    <div className={styles.firstLogin} >
                        <div color='white'>Hello, Please wait for admin to give you permission</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FirstLogin
// const Loader = ({
//     animation = "border",
//     role = "status",
//     innerClassName = "visually-hidden",
//     loaderText = ""
// }: ILoader) => {

//     return (
//         <Spinner animation={animation} role={role}>
//             <span className={innerClassName}>{loaderText}</span>
//         </Spinner>
//     );
// };

// export default Loader;
